<template>
    <span>
      <a class="tdclickable data-table-action"
         v-b-tooltip.hover
         @click="resetPassword"
         :title="$t('reset_password')">
          <MailSvg class="svg-light"/><span class="action-button-mob-title">{{ $t('reset_password') }}</span>
        </a>

      <a class="tdclickable data-table-action"
         v-b-tooltip.hover
         @click="resetIP"
         title="Сбросить IP - следующий ip запроса будет записан как новый разрешенный">
          <RefreshSvg class="svg-light"/><span class="action-button-mob-title">Сбросить IP - следующий ip запроса будет записан как новый разрешенный</span>
        </a>

      <b-modal v-if="showModal"
               id="api-access-reset-modal"
               @hidden="onHide">
        <div v-if="!password && superadmins.length && !loading">
          <div class="pb-3">Выберите, кому отправить письмо с логином / паролем</div>
          <a v-for="superadmin in superadmins"
               :key="`superadmin-${superadmin.id}`"
               @click="superadminSelected(superadmin.id)"
               class="py-2 d-block pointer">
            {{ superadmin.full_name }} ({{ superadmin.email }})
          </a>
        </div>
        <div v-if="password && !loading">
          Новый пароль:
          <span class="font-weight-bold text-primary">{{ password }}</span>
        </div>
        <template #modal-footer="{ close }">
      <div class="modal-footer-buttons">
        <b-button class="cancel"
                  variant="themed"
                  @click="close()">
          {{ $t('close') }}
        </b-button>
      </div>
    </template>
      </b-modal>
    </span>
</template>

<script setup>
import MailSvg from '@/assets/svg-vue/marketing/mail_forward.svg'
import RefreshSvg from '@/assets/svg-vue/general/refresh2.svg'
import { SuperadminService } from "@/services/api/superadmin.api.service"
import {computed, getCurrentInstance, nextTick, onMounted, ref} from "vue"
import { EloquentService } from "@/services/api/eloquent.api.service"
import { useStore } from "vuex"

const props = defineProps({
  object: {
    type: Object
  }
})

const store = useStore()

const showModal = ref(false)
const password = ref('')
const superadmins = ref([])
const superadminId = ref(null)
const loading = computed(() => store.state.dom.loading)

const clinic = computed(() => store.state.auth.clinic)

let bvModal = null

const resetPassword = async () => {
  await loadUsers()

  showModal.value = true

  await nextTick()

  bvModal.show('api-access-reset-modal')
}

const submitPasswordReset = async () => {
  try {
    const res = await SuperadminService.resetAPIAccessPassword(props.object.id, {
      sendMailToUserId: superadminId.value
    })
    password.value = res.data
  } catch (error) {
    console.log(error)
  }
}

const loadUsers = async () => {
  const data = await EloquentService.dataTable('superadministrator', 1, {
    pagination: 1000,
    condition: {
      clinic_id: clinic.value.id,
      blocked: 0,
    }
  }, true, true)
  superadmins.value = data.data.result.data
}

onMounted(() => {
  const instance = (getCurrentInstance())
  bvModal = instance?.ctx?._bv__modal
})

const onHide = () => {
  showModal.value = false
  password.value = ''
  superadminId.value = null
}

const superadminSelected = (val) => {
  superadminId.value = val
  submitPasswordReset()
}

const resetIP = async () => {
  try {
    await SuperadminService.resetAPIAccessIP(props.object.id)
    store.commit('incrementDataTableCounter')
  } catch (error) {
    console.log(error)
  }
}
</script>
